import { RootState } from "../store";
import { ICollectionYardsList } from "../types/collectionYardsSettings";

export const getCollectionYardsList = (state: RootState): ICollectionYardsList =>
  state.collectionYardsSettings.collectionYards;
